module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-list-item",
    class: ( _obj = {
      'cart-mode': _vm.cartMode, 'is-catalog': _vm.isCatalog
    }, _obj[("sku--" + (_vm.product.sku))] = 1, _obj )
  }, [_c('h3', {
    staticClass: "page-title text-center"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    class: _vm.wrapperClasses
  }, [_c('div', {
    staticClass: "product",
    class: _vm.extraClasses
  }, [_c('div', {
    staticClass: "product__block--form"
  }, [_c('product-donate-type', {
    attrs: {
      "product": _vm.product
    },
    on: {
      "input": _vm.updateDonateType
    },
    model: {
      value: (_vm.donateType),
      callback: function($$v) {
        _vm.donateType = $$v
      },
      expression: "donateType"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-border radius block"
  }, [_c('product-donate-choice', {
    ref: "donateChoice",
    attrs: {
      "show-donate-type": false,
      "product": _vm.product,
      "choices": _vm.donateConfig.choices,
      "choiceDescriptions": _vm.donateConfig.descriptions,
      "minimum": 20,
      "defaultAmount": _vm.donateConfig.default,
      "classes": _vm.donateChoiceClasses
    }
  }), _vm._v(" "), (_vm.allowedMonthly && _vm.$store.state.donateType === 'monthly') ? _c('div', {
    staticClass: "text-center"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forceDaily),
      expression: "forceDaily"
    }],
    staticClass: "form-check-input",
    staticStyle: {
      "position": "static",
      "left": "0"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.forceDaily) ? _vm._i(_vm.forceDaily, null) > -1 : (_vm.forceDaily)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.forceDaily,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.forceDaily = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.forceDaily = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.forceDaily = $$c
        }
      }
    }
  }), _vm._v(" [Testing] Force recurring period to daily\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.product.sku === 'edusandbox') ? _c('div', {
    staticClass: "sandbox-provinces-select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSandboxProvince),
      expression: "selectedSandboxProvince"
    }],
    staticClass: "form__input text-left sandbox-provinces-select",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSandboxProvince = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sandboxProvinces), function(p) {
    return _c('option', {
      key: p.value,
      domProps: {
        "value": p.value
      }
    }, [_vm._v(_vm._s(p.name))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center my-4"
  }, [_c('product-cart-action', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cartMode),
      expression: "!cartMode"
    }],
    ref: "cartAction",
    style: ({
      margin: 0
    }),
    attrs: {
      "stockAvailable": _vm.stockAvailable,
      "attributes": _vm.choices,
      "product": _vm.product,
      "initialQuantity": _vm.initialQuantity,
      "addToCartButton": false,
      "buyNowButton": false
    },
    on: {
      "resetQuantity": _vm.resetQuantity
    }
  }), _vm._v(" "), _c('product-cart-action', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cartMode),
      expression: "!cartMode"
    }],
    ref: "cartActionEduSandbox",
    staticClass: "hidden",
    style: ({
      margin: 0
    }),
    attrs: {
      "stockAvailable": _vm.stockAvailable,
      "attributes": _vm.choices,
      "product": _vm.productEduSandbox,
      "initialQuantity": _vm.initialQuantity,
      "addToCartButton": false,
      "buyNowButton": false
    },
    on: {
      "resetQuantity": _vm.resetQuantity
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn-md font-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.donate($event)
      }
    }
  }, [_vm._v("บริจาค")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mb-2 mb-md-4 mt-3 mt-md-4"
  })], 1)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec835532", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec835532","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductListItem.vue
// module id = 761
// module chunks = 1